import React from 'react';
import { Box, Typography, Stepper, Step, StepLabel } from '@mui/material';
import PropTypes from 'prop-types';
import { PALETTE, GRADIENTS } from '../theme';

/**
 * Section header for the Photo Shaper tool — page title + a 4-step stepper.
 *
 * Title is "Shape your photo" (action-oriented) instead of "Map Shaper" so
 * it doesn't visually duplicate the brand wordmark in the TopNav above.
 */
const StepProgress = ({ currentStep, steps }) => (
    <Box sx={{ maxWidth: 800, mx: 'auto', mb: { xs: 2, sm: 3 } }}>
        <Typography
            component="h1"
            sx={{
                textAlign: 'center',
                mb: { xs: 1.25, sm: 2 },
                fontWeight: 800,
                fontSize: { xs: '1.75rem', sm: '2.25rem' },
                letterSpacing: '-0.02em',
                lineHeight: 1.1,
                background: GRADIENTS.headline,
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                color: 'transparent'
            }}
        >
            Shape your photo
        </Typography>
        <Stepper activeStep={currentStep} alternativeLabel>
            {steps.map((step) => (
                <Step key={step.label}>
                    <StepLabel
                        icon={step.icon}
                        sx={{
                            '& .MuiStepLabel-iconContainer .MuiSvgIcon-root': {
                                fontSize: { xs: '1.4rem', sm: '1.85rem' }
                            },
                            '& .MuiStepLabel-label': {
                                color: PALETTE.text,
                                fontWeight: 600,
                                fontSize: { xs: '0.82rem', sm: '0.95rem' },
                                mt: { xs: 0.4, sm: 0.75 }
                            }
                        }}
                    >
                        {step.label}
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    </Box>
);

StepProgress.propTypes = {
    currentStep: PropTypes.number.isRequired,
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.element.isRequired
        })
    ).isRequired
};

export default StepProgress;
